import { EventMessage } from '@/common/analytics/gtm/types';
import { getOrCreateAthenaUserIdCookie } from '@/common/athena/checkAndSetAthenaCookie';
import { ConfigPublic } from '@/common/config.public';

const createAthenaImpressionData = (impressionMessages: EventMessage[]) => {
  const userId = getOrCreateAthenaUserIdCookie();

  return impressionMessages.map(({ message, metadata }) => ({
    id: `${message.index + 1}_${message.externalId}_${userId}`,
    itemId: message.internalId.toString(),
    itemCollectionId: message.externalId.toString(),
    user: userId,
    time: Date.now(),
    context: {
      href: window.location.href,
      itemListId: `PT:${metadata.athenaPageName}|LT:${metadata.listingType}|LF:${metadata.listingFunction}`,
      position: message.index + 1,
    },
  }));
};

export const trackAthenaImpression = async (impressionMessages: EventMessage[]) => {
  try {
    await fetch(new URL(`/i/imp`, ConfigPublic.AthenaApi).toString(), {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(createAthenaImpressionData(impressionMessages)),
      headers: { 'Content-Type': 'application/json' },
    });
  } catch (error) {
    console.error('Athena Impression send error! ', error);
  }
};
